import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AdminDashboardPage from "./pages/portal/admin/AdminDashboardPage";
import StudentDashboardPage from "./pages/portal/student/StudentDashboardPage";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { setLogoutHandler } from "./services/APIIntercepter";
import RoleRestrictedRoute from "./utility/RoleRestrictedRoute";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ClassManagePage from "./pages/portal/admin/ClassManagePage";
import ClassScheduleManagePage from "./pages/portal/admin/ClassScheduleManagePage";
import StaffManagePage from "./pages/portal/admin/StaffManagePage";
import StudentListPage from "./pages/portal/admin/StudentListPage";
import StudentDetailsPage from "./pages/portal/admin/StudentDetailsPage";
import ClassDetailsPage from "./pages/portal/student/ClassDetailsPage";
import ClassMonthDetailsPage from "./pages/portal/student/ClassMonthDetailsPage";
import ClassMonthPaymentPage from "./pages/portal/student/ClassMonthPaymentPage";
import PaymentHistoryPage from "./pages/portal/student/PaymentHistoryPage";
import BankTransferManagePage from "./pages/portal/admin/BankTransferManagePage";
import BannerManagePage from "./pages/portal/admin/BannerManagePage";
import ProfilePage from "./pages/portal/student/ProfilePage";
import EnrolledClassesPage from "./pages/portal/student/EnrolledClassesPage";
import ClassScheduleDetailsPage from "./pages/portal/student/ClassScheduleDetailsPage";
import Home1 from "./pages/Home1";
import ForgotPassword from "./pages/ForgotPassword";
import { RoutePaths } from "./utility/RoutePaths";
import ScheduleDocumentManagePage from "./pages/portal/admin/ScheduleDocumentManagePage";
import StudyPacksPage from "./pages/portal/student/StudyPacksPage";
import ManagePastPapers from "./pages/portal/admin/ManagePastPapers";
import ManagePastPaperFilesPage from "./pages/portal/admin/ManagePastPaperFilesPage";
import ManageSeminars from "./pages/portal/admin/ManageSeminars";
import SeminarsPage from "./pages/portal/student/SeminarsPage";
import SeminarDetailsPage from "./pages/portal/student/SeminarDetailsPage";
import SeminarPaymentPage from "./pages/portal/student/SeminarPaymentPage";
import ManageSeminarFilesPage from "./pages/portal/admin/ManageSeminarFilesPage";
import ManageSeminarStudents from "./pages/portal/admin/ManageSeminarStudents";
import ManageCourses from "./pages/portal/admin/ManageCourses";
import ManageCourseFilesPage from "./pages/portal/admin/ManageCourseFilesPage";
import ManageCourseStudents from "./pages/portal/admin/ManageCourseStudents";
import CoursesPage from "./pages/portal/student/CoursesPage";
import CourseDetailsPage from "./pages/portal/student/CourseDetailsPage";
import CoursePaymentPage from "./pages/portal/student/CoursePaymentPage";
import PastPapersPage from "./pages/portal/student/PastPapersPage";
import FreeClassesPage from "./pages/portal/student/FreeClassesPage";
import PastPaperDetailsPage from "./pages/portal/student/PastPaperDetailsPage";
import OnlinePaymentResultPage from "./pages/portal/student/OnlinePaymentResultPage";

const ADMIN_ROLE = 1;
const STAFF_ROLE = 2;

function AppWithAuth() {
  const { logout } = useAuth();

  useEffect(() => {
    setLogoutHandler(logout);
  }, [logout]);

  const handleRightClick = (e) => {
    e.preventDefault();
  };

  return (
    <Router>
      <div className="App" onContextMenu={handleRightClick}>
        <Routes>
          <Route path={RoutePaths.HOME} element={<Home />} />
          <Route path="/home1" element={<Home1 />} />
          <Route path={RoutePaths.LOGIN} element={<Login />} />
          <Route path={RoutePaths.REGISTER} element={<Register />} />
          <Route
            path={RoutePaths.FORGOT_PASSWORD}
            element={<ForgotPassword />}
          />

          <Route
            path={RoutePaths.STUDENT_CLASS_SCHEDULE_DETAILS_PAGE}
            element={<ClassScheduleDetailsPage />}
          />
          <Route
            path={RoutePaths.STUDENT_DASHBOARD_PAGE}
            element={<StudentDashboardPage />}
          />
          <Route
            path={RoutePaths.STUDENT_PROFILE_PAGE}
            element={<ProfilePage />}
          />
          <Route
            path={RoutePaths.STUDENT_ENROLLED_CLASSES_PAGE}
            element={<EnrolledClassesPage />}
          />
          <Route
            path={RoutePaths.STUDENT_CLASS_DETAILS_PAGE}
            element={<ClassDetailsPage />}
          />
          <Route
            path={RoutePaths.STUDENT_CLASS_MONTH_DETAILS_PAGE}
            element={<ClassMonthDetailsPage />}
          />
          <Route
            path={RoutePaths.STUDENT_CLASS_MONTH_PAYMENT_PAGE}
            element={<ClassMonthPaymentPage />}
          />
          <Route
            path={RoutePaths.STUDENT_PAYMENT_HISTORY_PAGE}
            element={<PaymentHistoryPage />}
          />
          <Route
            path={RoutePaths.STUDENT_STUDY_PACKS_PAGE}
            element={<StudyPacksPage />}
          />
          <Route
            path={RoutePaths.STUDENT_PAST_PAPERS_PAGE}
            element={<PastPapersPage />}
          />
          <Route
            path={RoutePaths.STUDENT_FREE_CLASSES_PAGE}
            element={<FreeClassesPage />}
          />
          <Route
            path={RoutePaths.STUDENT_SEMINARS_PAGE}
            element={<SeminarsPage />}
          />
          <Route
            path={RoutePaths.STUDENT_SEMINAR_DETAILS_PAGE}
            element={<SeminarDetailsPage />}
          />
          <Route
            path={RoutePaths.STUDENT_SEMINAR_PAYMENT_PAGE}
            element={<SeminarPaymentPage />}
          />
          <Route
            path={RoutePaths.STUDENT_PAST_PAPER_DETAILS_PAGE}
            element={<PastPaperDetailsPage />}
          />
          <Route
            path={RoutePaths.STUDENT_ONLINE_PAYMENT_RESULT_PAGE}
            element={<OnlinePaymentResultPage />}
          />
          <Route
            path={RoutePaths.STUDENT_COURSES_PAGE}
            element={<CoursesPage />}
          />
          <Route
            path={RoutePaths.STUDENT_COURSE_DETAILS_PAGE}
            element={<CourseDetailsPage />}
          />
          <Route
            path={RoutePaths.STUDENT_COURSE_PAYMENT_PAGE}
            element={<CoursePaymentPage />}
          />

          <Route
            path={RoutePaths.ADMIN_DASHBOARD_PAGE}
            element={
              <RoleRestrictedRoute
                allowedRoles={[ADMIN_ROLE, STAFF_ROLE]}
                element={<AdminDashboardPage />}
              />
            }
          />
          <Route
            path={RoutePaths.ADMIN_CLASS_PAGE}
            element={
              <RoleRestrictedRoute
                allowedRoles={[ADMIN_ROLE]}
                element={<ClassManagePage />}
              />
            }
          />
          <Route
            path={RoutePaths.ADMIN_CLASS_SCHEDULE_PAGE}
            element={
              <RoleRestrictedRoute
                allowedRoles={[ADMIN_ROLE, STAFF_ROLE]}
                element={<ClassScheduleManagePage />}
              />
            }
          />
          <Route
            path={RoutePaths.ADMIN_STAFF_MANAGE_PAGE}
            element={
              <RoleRestrictedRoute
                allowedRoles={[ADMIN_ROLE]}
                element={<StaffManagePage />}
              />
            }
          />
          <Route
            path={RoutePaths.ADMIN_STUDENT_MANAGE_PAGE}
            element={
              <RoleRestrictedRoute
                allowedRoles={[ADMIN_ROLE, STAFF_ROLE]}
                element={<StudentListPage />}
              />
            }
          />
          <Route
            path={RoutePaths.ADMIN_STUDENT_DETAILS_PAGE}
            element={
              <RoleRestrictedRoute
                allowedRoles={[ADMIN_ROLE, STAFF_ROLE]}
                element={<StudentDetailsPage />}
              />
            }
          />
          <Route
            path={RoutePaths.ADMIN_BANK_TRANSFER_MANAGE_PAGE}
            element={
              <RoleRestrictedRoute
                allowedRoles={[ADMIN_ROLE, STAFF_ROLE]}
                element={<BankTransferManagePage />}
              />
            }
          />
          <Route
            path={RoutePaths.ADMIN_BANNER_MANAGE_PAGE}
            element={
              <RoleRestrictedRoute
                allowedRoles={[ADMIN_ROLE, STAFF_ROLE]}
                element={<BannerManagePage />}
              />
            }
          />
          <Route
            path={RoutePaths.ADMIN_SCHEDULE_DOCUMENT_MANAGE_PAGE}
            element={
              <RoleRestrictedRoute
                allowedRoles={[ADMIN_ROLE, STAFF_ROLE]}
                element={<ScheduleDocumentManagePage />}
              />
            }
          />
          <Route
            path={RoutePaths.ADMIN_MANAGE_PAST_PAPERS_PAGE}
            element={
              <RoleRestrictedRoute
                allowedRoles={[ADMIN_ROLE, STAFF_ROLE]}
                element={<ManagePastPapers />}
              />
            }
          />
          <Route
            path={RoutePaths.ADMIN_MANAGE_PAST_PAPER_FILES_PAGE}
            element={
              <RoleRestrictedRoute
                allowedRoles={[ADMIN_ROLE, STAFF_ROLE]}
                element={<ManagePastPaperFilesPage />}
              />
            }
          />
          <Route
            path={RoutePaths.ADMIN_MANAGE_SEMINARS_PAGE}
            element={
              <RoleRestrictedRoute
                allowedRoles={[ADMIN_ROLE, STAFF_ROLE]}
                element={<ManageSeminars />}
              />
            }
          />
          <Route
            path={RoutePaths.ADMIN_MANAGE_SEMINAR_FILES_PAGE}
            element={
              <RoleRestrictedRoute
                allowedRoles={[ADMIN_ROLE, STAFF_ROLE]}
                element={<ManageSeminarFilesPage />}
              />
            }
          />
          <Route
            path={RoutePaths.ADMIN_MANAGE_SEMINAR_STUDENTS_PAGE}
            element={
              <RoleRestrictedRoute
                allowedRoles={[ADMIN_ROLE, STAFF_ROLE]}
                element={<ManageSeminarStudents />}
              />
            }
          />
          <Route
            path={RoutePaths.ADMIN_MANAGE_COURSES_PAGE}
            element={
              <RoleRestrictedRoute
                allowedRoles={[ADMIN_ROLE, STAFF_ROLE]}
                element={<ManageCourses />}
              />
            }
          />
          <Route
            path={RoutePaths.ADMIN_MANAGE_COURSE_FILES_PAGE}
            element={
              <RoleRestrictedRoute
                allowedRoles={[ADMIN_ROLE, STAFF_ROLE]}
                element={<ManageCourseFilesPage />}
              />
            }
          />
          <Route
            path={RoutePaths.ADMIN_MANAGE_COURSE_STUDENTS_PAGE}
            element={
              <RoleRestrictedRoute
                allowedRoles={[ADMIN_ROLE, STAFF_ROLE]}
                element={<ManageCourseStudents />}
              />
            }
          />
        </Routes>

        {/* 👇 Add the ToastContainer once here */}
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
      </div>
    </Router>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppWithAuth />
    </AuthProvider>
  );
}

export default App;
